import { Clinic } from 'src/@types/Clinic'

export const getClinicLocation = (clinic: Partial<Clinic>) => {
  return `${clinic.street} ${clinic.houseNumber}, ${clinic.zipCode} ${clinic.city}`
}

export const getClinicLocationUrl = (clinic: Partial<Clinic>) => {
  return `https://maps.google.com/maps?q=${clinic.lat},${clinic.long}`
}
